import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "./index.css";
import App from "./App";

// CSRF defense: mark all requests as XHR so the backend can reject cross-site
// HTML-form posts (which cannot set custom headers) on multipart endpoints.
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
